import { CommonModule } from '@angular/common';
import { Component, inject, effect, ViewChild, ElementRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbDatepickerModule, NgbModule, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@services/core/user.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import { BudgetGenerateService } from '@services/budget-generate.service';
import { ChildrenModel } from './children.model';
import { Entity } from '@model/entity.model';
import Swal from 'sweetalert2';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID, NgModule } from '@angular/core';

registerLocaleData(localeEs);


@Component({
  selector: 'app-children',
  standalone: true,
  imports: [ CommonModule,
    NgSelectModule,
    FormsModule, 
    ReactiveFormsModule,
    NgbDatepickerModule,
    NgbModule
  ],
  providers: [NgbModal,{ provide: LOCALE_ID, useValue: 'es-ES' }],
  templateUrl: './children.component.html',
  styleUrl: './children.component.css',
})
export class ChildrenComponent {
  @ViewChild('modal_children', { static: true }) modalChildren: any;
  @ViewChild('ngSelectAssinet', { static: false }) ngSelectAssinet: NgSelectComponent;
  @ViewChild('ngSelect', { static: false }) ngSelect: NgSelectComponent;
  @ViewChild('nameInput') nameInput: ElementRef;
  private modalRef: NgbModalRef;
  private userService = inject(UserService);
  private _budgeGenrateService = inject(BudgetGenerateService);
  private entitySelected: Entity;
  public filter:ChildrenModel = new ChildrenModel();
  public dataEmployeeType;
  public dataListDiverse;
  public dataListChildren;
  public dataNgSelectAssinet;
  public dataDiverse;  
  public dataDiverseTemp;
  public dataChildren;
  public dataChildrenTemp=undefined;
  public txtFind;
  public tabArea = 'diverse';
  public modalHeaderDiverse: string;
  public modalHeaderChildren: string;
  public formDiverse: FormGroup;
  public formChildren: FormGroup;
  public id;
  public diverseFinded=false
  public diverseCopy;
  public isNewDiverse=false
  closeResult: string;
  modalOptions = {
    animation: true,
  };
  budgetVersionSelected;
  public budgetFund;
  public fundSelect;
  public budgetStatus;
  constructor(private modalService: NgbModal, private formBuilder: FormBuilder,) {
    effect(() => {
      this.entitySelected = this.userService.sharingEntity();
      if (this.entitySelected && Object.keys(this.entitySelected).length > 0) {
      }
    });  
    effect(()=> {
			this.budgetVersionSelected = this.userService.sharingBudgetVersion();
      const budgetFundData = this.userService.sharingBudgetFund();
       if (this.budgetVersionSelected?.year) {  
        this.budgetFund=budgetFundData;
        this.fundSelect=budgetFundData[0].fundCode;     
        this.filter.year = this.budgetVersionSelected.year;
        this.filter.version = this.budgetVersionSelected.version; 
        this.budgetStatus = this.budgetVersionSelected.status;
        this.getChildren();
        this.getDiverse();
      }
		})
  }

  /*trae los datos diverse en el servicio de budget  */
  getDiverse() {
    this._budgeGenrateService.getDepartamentEmployee(this.filter).subscribe((diverso) => {
      diverso=diverso.filter(d=>d.isActive===true)
      const arrayEmployeeType=[1,2]
      const dataFiltred=diverso.filter(d=>arrayEmployeeType.includes(d.type));
      this.dataDiverse = dataFiltred  
      this.dataDiverseTemp=this.dataDiverse;    
        this.dataDiverseTemp=JSON.parse(JSON.stringify(this.dataDiverse));
        this.dataListDiverse=this.mapSelectAassinet(diverso)
    }, (error => console.error(error)));
  }

  
  mapSelectAassinet(diverse) {
    diverse=diverse.filter(d=> !this.findEmployee(d.code))
    let newData = diverse.map((d) => {
      const name=d.names
       return {
        diverse: d.code,
        nameDiverse: d.code + ' - ' + name,
        name: name,
        isActive:true,
        disabled:false,
        
      }
    });
    return newData
  }


  /**crear formulario reactivo prima infantil*/
  createFormChildren() {
    this.formChildren = this.formBuilder.group({
      employeeCode: [null, [Validators.required]],
      names: ['', Validators.required],
      birthday: ['', [Validators.required,this.maxDateValidator]],
      hasDisability: [false]
    });
  }

  ngOnInit() {
    this.createFormChildren();
  }


 /**al momento de cerrar el ng select de busqueda busca actualiza la tabla de diversos  */
 onCloseNgSelectFind() {
  if(this.txtFind.length==0){
    this.dataChildren=this.dataChildrenTemp;
  }else{
    
    this.dataChildren=this.dataChildrenTemp.filter(d=>
      this.txtFind.includes(d.diverse)
    );
  }
}


  /**combina los datos del formDiverso con los datos q faltan para hacer la peticion en el servicio */
  newData(data) {
    data['entityCode'] = this.entitySelected?.code;
    data['year']=this.filter.year;
    data['version']=this.filter.version
    data['fundCode']=this.fundSelect
    
    return data;
  }

  /*mensaje de cargando */
  loading() {
    Swal.fire({
      title: 'Cargando...',
      html: 'Por favor, espere',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }


/**busca los diverso  */
  findEmployee(code): boolean {
    let isActive=false;
    isActive=!this.dataDiverse.some((diverse) => { return diverse.code === code })
    return isActive
   
	}


  ngSelectData(diverseList) {
    const seen = new Set();
    const uniqueList = [];
  
    diverseList.forEach(d => {
      const key = `${d.diverse}-${d.employee}`;
      if (!seen.has(key)) {
        seen.add(key);
        uniqueList.push({
          diverse: d.diverse,
          nameDiverse: d.diverse + ' - ' + d.employee,
          name: d.employee
        });
      }
    });
  
    return uniqueList;
  }
  


  

  /*trae los datos prima infantil en el servicio de budget  */
  getChildren() {
    this.loading();
    this._budgeGenrateService.getChildren(this.filter).subscribe(res => {
      this.dataListChildren=this.ngSelectData(res)
      this.dataChildrenTemp=JSON.parse(JSON.stringify(res))      
      this.dataChildren =res
      Swal.close();
    }, (error => console.error(error)) );
  }


  
  changeFund(fundCode) {
    this.fundSelect=fundCode;
    if(this.dataChildrenTemp){
    this.dataChildren = this.dataChildrenTemp.filter(d => 
      d.fundCode==this.fundSelect
    );
   // this.datalistEmployee[this.employeeType] = this.ngSelectDiverse(this.dataChildren[this.employeeType]);
    
  }
}


  /*abre los modales */
  open(content) {
    this.modalRef = this.modalService.open(content);
  }

   /*cierra los modales */
  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }


  validateDiverse(diverse){
    const foundItem = this.dataNgSelectAssinet.find(item => item.diverse === diverse);
    if (foundItem) {
      this.diverseFinded=true
    }
    this.diverseCopy=diverse
  }

  /**al momento de cerrer el ng select pasa el foco al input name y le asigna el valor de name  */
  onCloseNgSelectAssinet() {   
    const selected = this.dataNgSelectAssinet.find(i => i.diverse === this.formDiverse.get('code').value)
    if(selected?.name){
      this.formDiverse.get('names').patchValue(selected.name);
      this.nameInput.nativeElement.focus();
      this.nameInput.nativeElement.select();
    }
  }


  /**abre el modal del diverse */

  openModalChildren() {
    this.modalHeaderChildren = 'Nuevo';
    this.formChildren.get('employeeCode').enable()
    this.formChildren.markAsPristine();

    this.formChildren.reset();
    this.formChildren.patchValue({
      employeeCode:null,
      names:'',
      birthday:'',
      hasDisability:false
      
    })
    this.open(this.modalChildren);
    setTimeout(() => {
      this.ngSelect.focus();
    }, 0);
  }


  /**carga los datos al pinchar en la tabla editar */

  setFormChildren(params) {
    this.modalHeaderChildren = 'Modificar';
    this.id=params.id;
    this.formChildren.get('employeeCode').patchValue(params.diverse);
    this.formChildren.get('employeeCode').disable()
    this.formChildren.get('names').patchValue(params.names);
    this.formChildren.get('birthday').patchValue(params.birthday);
    this.formChildren.get('hasDisability').patchValue(params.hasDisability);
    this.formChildren.markAsPristine();
    this.open(this.modalChildren);
    setTimeout(() => {
      this.nameInput.nativeElement.focus();
    }, 0);
  }


  /**cambia la fecha en formato compatible para el mostrar campo de fecha */
  setDate(date?) {
    const expirationDate = date ? new Date(date) : new Date();
    let formatDate = {
      year: date ? expirationDate.getFullYear() : expirationDate.getFullYear() + 1,
      month: expirationDate.getMonth() + 1,
      day: date ? expirationDate.getDate() : expirationDate.getDate() + 1
    };
    return formatDate
  }

  /**cambia la fecha en formato compatible para guardar la fecha en la base de datos */
  setDateSave(date) {
    let year = date.year;
    let month = date.month < 10 ? `0${date.month}` : date.month;
    let day = date.day < 10 ? `0${date.day}` : date.day;
    let newDate = `${year}-${month}-${day}`
    return newDate;
  }


  /**Elimnar prima infantil */
  deleteChildren(params) {
    const loadingToast = Swal.fire({
      icon: 'warning',
      title: 'Alerta ',
      text: 'Eliminar: ' + params.diverse+ ' ' + params.names,
      toast: false,
      position: 'center',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      timer: null,
      timerProgressBar: false
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.close()
        this._budgeGenrateService.deleteChildren(params).subscribe(res => {
          this.getChildren();
        }, (error => console.error(error)))
      }
    });
  }



  /*envia la informacion para un nueva prima infantil*/
  submitChildrenNew() {
    if (this.formChildren.valid) {
      let dataSave = this.newData(this.formChildren.value);
      this._budgeGenrateService.saveChildren(dataSave).subscribe(res => {        
        this.close();
        this.getChildren();
      }, (error => console.error(error)))
    }
  }

  /*envia la informacion para un actualizar prima infantil*/
  submitChildrenUpdate() {
    if (this.formChildren.valid) {
      let dataUpdate = this.newData(this.formChildren.value);
      dataUpdate['id']=this.id;
      this._budgeGenrateService.updateChildren(dataUpdate).subscribe(res => {   
        this.close();
        this.getChildren();
      }, (error => console.error(error)))
    }
  }


  /*envia la informacion para actualizar toda prima infantil de la entidad*/
  UpdatePremiumChildren() {
    let params={};
    params['entityCode']=this.entitySelected.code;
    params['year']=this.filter.year;
    params['version']=this.filter.version;
    this._budgeGenrateService.updatePremiumChildren(params).subscribe(res => {
      this.getChildren();
    }, (error => console.error(error)))
  }
  
  
maxDateValidator(control) {
  if (!control.value) return null;

  const selectedDate = new Date(control.value);
  const today = new Date();
  const maxDate = new Date();

  // Permitimos hasta 5 meses más adelante
  maxDate.setMonth(maxDate.getMonth() + 5);

  // Normalizamos todas las fechas al inicio del día
  today.setHours(0, 0, 0, 0);
  maxDate.setHours(0, 0, 0, 0);
  selectedDate.setHours(0, 0, 0, 0);

  // Si es posterior a 5 meses en el futuro, es inválida
  if (selectedDate > maxDate) {
    return { dateInvalid: true };
  }

  return null;
}



}



